import { createSelector } from 'reselect'

const getSummary = (state: any) =>
  (state &&
    state.entities &&
    state.entities.dealerVehicleSummaryCache &&
    state.entities.dealerVehicleSummaryCache.byId) ||
  {}

export default createSelector(getSummary, (summaries) => (id: any) =>
  (summaries[id] as Cinch.DealerVehicleSummaryResponse) || {},
)
